var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7639 19.753L17.5028 18.0094V27.2001C17.5028 27.2378 17.479 27.3171 17.3994 27.3969C17.3198 27.4767 17.2412 27.5 17.205 27.5H10.4231C5.47381 27.5 1.11679 23.8745 0.547803 18.9466C-0.0179533 13.2519 4.52714 8.5 10.0242 8.5H10.2237H10.6269L10.7123 8.10595C11.6622 3.725 15.457 0.5 19.9977 0.5C23.979 0.5 27.1967 2.77443 28.7162 6.20261L28.8481 6.5H29.1734C32.6672 6.5 35.4553 9.45589 35.4553 13V14.2389L34.5986 14.5231L35.7451 15.0537C38.1514 16.1673 39.8149 18.7623 39.4496 21.728C38.8882 25.0742 35.9143 27.5 32.5641 27.5H22.79C22.7537 27.5 22.6751 27.4767 22.5956 27.3969C22.5161 27.3173 22.4922 27.2379 22.4922 27.2001V18.0095L24.2312 19.7533L24.2312 19.7533C25.2244 20.7491 26.7386 20.7491 27.7317 19.7533C28.7242 18.7582 28.7242 17.2423 27.7317 16.2472L21.7476 10.2472C20.7544 9.25138 19.2402 9.25138 18.2471 10.2472L12.263 16.2472C11.2705 17.2423 11.2705 18.7582 12.263 19.7533L12.2631 19.7534C12.4921 19.9828 12.741 20.1749 13.037 20.3068C13.3353 20.4397 13.6557 20.5001 14.0134 20.5001C14.3711 20.5001 14.6916 20.4397 14.9899 20.3067C15.286 20.1748 15.5349 19.9826 15.7639 19.753Z",
    fill: "url(#paint0_linear_4825_1795)",
    stroke: "url(#paint1_linear_4825_1795)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4825_1795",
    x1: 13.5,
    y1: 4.03396e-7,
    x2: 25.5,
    y2: 32.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EB3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A59EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4825_1795",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35A4FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.28076a89a84dccdd155b5bb29af37f1b.svg";
export { ForwardRef as ReactComponent };